<template>
  <Modal :modalActive="modalActive" @cerrar-modal="onCerrar">
    <div class="mep-wrap">

      <div class="mep-header">
        <span class="mep-badge">Landing</span>
        <h5 class="mep-title">Editar parámetros</h5>
      </div>

      <div v-if="cargandoOpciones" class="mep-loading">
        <i class="fa fa-spinner fa-spin me-1"></i> Cargando opciones…
      </div>

      <template v-else>
        <div class="mep-params">

          <!-- Mercado -->
          <div class="mep-group">
            <div class="mep-label-row">
              <span class="mep-label">Mercado</span>
              <button class="mep-add-btn" @click="mostrarAgregar('mercado')" title="Añadir mercado">+</button>
            </div>
            <div class="mep-radio-grid">
              <label v-for="m in opciones.mercado" :key="m.valor" class="mep-pill" :class="{ active: params.mercado === m.valor }">
                <input type="radio" v-model="params.mercado" :value="m.valor" class="mep-hidden">
                {{ m.valor }}
              </label>
            </div>
            <div v-if="agregar.tipo === 'mercado'" class="mep-inline-add">
              <input
                ref="inputAgregar"
                v-model="agregar.valor"
                class="mep-add-input"
                placeholder="Ej: BRA"
                maxlength="20"
                @keydown.enter.prevent="confirmarAgregar"
                @keydown.esc="cancelarAgregar"
              />
              <button class="mep-add-ok" :disabled="agregar.guardando || !agregar.valor.trim()" @click="confirmarAgregar">
                <i v-if="agregar.guardando" class="fa fa-spinner fa-spin"></i>
                <span v-else>✓</span>
              </button>
              <button class="mep-add-cancel" @click="cancelarAgregar">✕</button>
              <span v-if="agregar.error" class="mep-add-error">{{ agregar.error }}</span>
            </div>
          </div>

          <!-- Tipo de campaña -->
          <div class="mep-group">
            <div class="mep-label-row">
              <span class="mep-label">Tipo de campaña</span>
              <button class="mep-add-btn" @click="mostrarAgregar('tipo_campana')" title="Añadir tipo de campaña">+</button>
            </div>
            <div class="mep-radio-row">
              <label v-for="t in opciones.tipo_campana" :key="t.valor" class="mep-pill mep-pill--lg" :class="{ active: params.tipoCampana === t.valor }">
                <input type="radio" v-model="params.tipoCampana" :value="t.valor" class="mep-hidden">
                <span class="mep-pill-cod">{{ t.valor }}</span>
                <span class="mep-pill-desc">{{ t.label }}</span>
              </label>
            </div>
            <div v-if="agregar.tipo === 'tipo_campana'" class="mep-inline-add">
              <input
                ref="inputAgregar"
                v-model="agregar.valor"
                class="mep-add-input mep-add-input--sm"
                placeholder="Código (ej: BRD)"
                maxlength="10"
                @keydown.esc="cancelarAgregar"
              />
              <input
                v-model="agregar.label"
                class="mep-add-input"
                placeholder="Descripción (ej: Brand)"
                maxlength="100"
                @keydown.enter.prevent="confirmarAgregar"
                @keydown.esc="cancelarAgregar"
              />
              <button class="mep-add-ok" :disabled="agregar.guardando || !agregar.valor.trim()" @click="confirmarAgregar">
                <i v-if="agregar.guardando" class="fa fa-spinner fa-spin"></i>
                <span v-else>✓</span>
              </button>
              <button class="mep-add-cancel" @click="cancelarAgregar">✕</button>
              <span v-if="agregar.error" class="mep-add-error">{{ agregar.error }}</span>
            </div>
          </div>

          <!-- Tipo de audiencia -->
          <div class="mep-group">
            <div class="mep-label-row">
              <span class="mep-label">Tipo de audiencia</span>
              <button class="mep-add-btn" @click="mostrarAgregar('tipo_audiencia')" title="Añadir tipo de audiencia">+</button>
            </div>
            <div class="mep-radio-row">
              <label v-for="a in opciones.tipo_audiencia" :key="a.valor" class="mep-pill" :class="{ active: params.tipoAudiencia === a.valor }">
                <input type="radio" v-model="params.tipoAudiencia" :value="a.valor" class="mep-hidden">
                {{ a.valor }}
              </label>
            </div>
            <div v-if="agregar.tipo === 'tipo_audiencia'" class="mep-inline-add">
              <input
                ref="inputAgregar"
                v-model="agregar.valor"
                class="mep-add-input"
                placeholder="Ej: RETENCION"
                maxlength="30"
                @keydown.enter.prevent="confirmarAgregar"
                @keydown.esc="cancelarAgregar"
              />
              <button class="mep-add-ok" :disabled="agregar.guardando || !agregar.valor.trim()" @click="confirmarAgregar">
                <i v-if="agregar.guardando" class="fa fa-spinner fa-spin"></i>
                <span v-else>✓</span>
              </button>
              <button class="mep-add-cancel" @click="cancelarAgregar">✕</button>
              <span v-if="agregar.error" class="mep-add-error">{{ agregar.error }}</span>
            </div>
          </div>

          <!-- Tipo de segmentación -->
          <div class="mep-group">
            <div class="mep-label-row">
              <span class="mep-label">Tipo de segmentación <span class="mep-opt">(opcional)</span></span>
              <button class="mep-add-btn" @click="mostrarAgregar('segmentacion')" title="Añadir segmentación">+</button>
            </div>
            <select v-model="params.tipoSegmentacion" class="mep-select">
              <option value="">— Sin segmentación específica —</option>
              <option v-for="s in opciones.segmentacion" :key="s.valor" :value="s.valor"
                :style="s.valor === segmentacionNueva ? { color: '#ffd700', fontWeight: '700' } : {}">
                {{ s.valor }}{{ s.valor === segmentacionNueva ? ' ✦' : '' }}
              </option>
            </select>
            <div v-if="agregar.tipo === 'segmentacion'" class="mep-inline-add">
              <input
                ref="inputAgregar"
                v-model="agregar.valor"
                class="mep-add-input"
                placeholder="Ej: SIM+TEN"
                maxlength="50"
                @keydown.enter.prevent="confirmarAgregar"
                @keydown.esc="cancelarAgregar"
              />
              <button class="mep-add-ok" :disabled="agregar.guardando || !agregar.valor.trim()" @click="confirmarAgregar">
                <i v-if="agregar.guardando" class="fa fa-spinner fa-spin"></i>
                <span v-else>✓</span>
              </button>
              <button class="mep-add-cancel" @click="cancelarAgregar">✕</button>
              <span v-if="agregar.error" class="mep-add-error">{{ agregar.error }}</span>
            </div>
          </div>

        </div>

        <div v-if="errorMsg" class="mep-error">{{ errorMsg }}</div>

        <div class="mep-actions">
          <button class="mep-btn mep-btn--sec" :disabled="guardando" @click="onCerrar">Cancelar</button>
          <button class="mep-btn mep-btn--pri" :disabled="guardando || !valido" @click="guardar">
            <i v-if="guardando" class="fa fa-spinner fa-spin me-1"></i>
            Guardar
          </button>
        </div>
      </template>

    </div>
  </Modal>
</template>

<script>
import Modal from '@/views/components/Modal.vue';
import campanasService from '@/services/campanas.service.js';

export default {
  name: 'ModalEditarParametros',
  components: { Modal },

  props: {
    modalActive: { type: Boolean, default: false },
    landing:     { type: Object,  default: null },
  },

  emits: ['cerrar-modal', 'guardado'],

  data() {
    return {
      cargandoOpciones: false,
      opciones: {
        mercado:        [],
        tipo_campana:   [],
        tipo_audiencia: [],
        segmentacion:   [],
      },
      params: { mercado: '', tipoCampana: '', tipoAudiencia: '', tipoSegmentacion: '' },
      guardando: false,
      errorMsg: '',
      agregar: { tipo: null, valor: '', label: '', guardando: false, error: '' },
      segmentacionNueva: null,
    };
  },

  computed: {
    valido() {
      return this.params.mercado && this.params.tipoCampana && this.params.tipoAudiencia;
    },
  },

  watch: {
    modalActive(val) {
      if (val) this.cargar();
    },
  },

  methods: {
    async cargar() {
      this.errorMsg = '';
      this.guardando = false;
      this.cancelarAgregar();

      const l = this.landing;
      this.params = {
        mercado:          l?.mercado           || '',
        tipoCampana:      l?.tipo_campana      || '',
        tipoAudiencia:    l?.tipo_audiencia    || '',
        tipoSegmentacion: l?.tipo_segmentacion || '',
      };

      if (!this.opciones.mercado.length) {
        await this.cargarOpciones();
      }
    },

    async cargarOpciones() {
      this.cargandoOpciones = true;
      try {
        const res = await campanasService.metaParametros();
        if (res?.data) {
          this.opciones.mercado        = res.data.mercado        || [];
          this.opciones.tipo_campana   = res.data.tipo_campana   || [];
          this.opciones.tipo_audiencia = res.data.tipo_audiencia || [];
          this.opciones.segmentacion   = res.data.segmentacion   || [];
        }
      } catch {
        this.errorMsg = 'No se pudieron cargar las opciones.';
      } finally {
        this.cargandoOpciones = false;
      }
    },

    mostrarAgregar(tipo) {
      this.agregar = { tipo, valor: '', label: '', guardando: false, error: '' };
      this.$nextTick(() => {
        this.$refs.inputAgregar?.focus();
      });
    },

    cancelarAgregar() {
      this.agregar = { tipo: null, valor: '', label: '', guardando: false, error: '' };
    },

    async confirmarAgregar() {
      const { tipo, valor, label } = this.agregar;
      if (!valor.trim()) return;

      this.agregar.guardando = true;
      this.agregar.error = '';
      try {
        const res = await campanasService.metaParametrosCrear(tipo, valor.trim(), label?.trim() || null);
        if (res?.ok && res.data) {
          this.opciones[tipo].push(res.data);
          // Selecciona automáticamente la opción recién creada
          if (tipo === 'mercado')        this.params.mercado         = res.data.valor;
          if (tipo === 'tipo_campana')   this.params.tipoCampana     = res.data.valor;
          if (tipo === 'tipo_audiencia') this.params.tipoAudiencia   = res.data.valor;
          if (tipo === 'segmentacion') {
            this.params.tipoSegmentacion = res.data.valor;
            this.opciones.segmentacion.sort((a, b) => a.valor.localeCompare(b.valor, undefined, { sensitivity: 'base' }));
            this.segmentacionNueva = res.data.valor;
          }
          this.cancelarAgregar();
        }
      } catch (e) {
        const msg = e?.response?.data?.message || e?.response?.data?.errors?.valor?.[0] || 'Error al guardar';
        this.agregar.error = msg;
      } finally {
        this.agregar.guardando = false;
      }
    },

    async guardar() {
      if (!this.valido || !this.landing) return;
      this.guardando = true;
      this.errorMsg = '';
      try {
        await campanasService.landingEditar(this.landing.id, {
          mercado:           this.params.mercado,
          tipo_campana:      this.params.tipoCampana,
          tipo_audiencia:    this.params.tipoAudiencia,
          tipo_segmentacion: this.params.tipoSegmentacion || null,
        });
        this.$emit('guardado');
        this.$emit('cerrar-modal');
      } catch {
        this.errorMsg = 'No se pudo guardar. Intenta de nuevo.';
      } finally {
        this.guardando = false;
      }
    },

    onCerrar() {
      this.segmentacionNueva = null;
      this.$emit('cerrar-modal');
    },
  },
};
</script>

<style scoped>
.mep-wrap {
  padding: 24px 28px;
  max-width: 620px;
  width: 100%;
}

.mep-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 20px;
}
.mep-badge {
  background: rgba(212,175,55,.15);
  color: var(--q-gold, #d4af37);
  font-size: .6rem;
  font-weight: 700;
  letter-spacing: .08em;
  text-transform: uppercase;
  border-radius: 4px;
  padding: 2px 8px;
}
.mep-title {
  margin: 0;
  font-size: 1rem;
  font-weight: 700;
  color: var(--q-text);
}

.mep-loading {
  padding: 32px 0;
  text-align: center;
  color: var(--q-muted);
  font-size: .85rem;
}

/* Grupos de parámetros */
.mep-params { display: flex; flex-direction: column; gap: 18px; }
.mep-group  { display: flex; flex-direction: column; gap: 8px; }

/* Label row con botón + */
.mep-label-row {
  display: flex;
  align-items: center;
  gap: 8px;
}
.mep-label {
  font-size: .68rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: .07em;
  color: var(--q-muted);
}
.mep-opt { font-weight: 400; text-transform: none; letter-spacing: 0; font-size: .75em; }

/* Botón "+" junto al label */
.mep-add-btn {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  border: 1px solid var(--q-green, #00e676);
  background: rgba(0, 230, 118, 0.1);
  color: var(--q-green, #00e676);
  font-size: .9rem;
  line-height: 1;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  transition: background .12s;
  flex-shrink: 0;
}
.mep-add-btn:hover {
  background: rgba(0, 230, 118, 0.22);
}

/* Formulario inline de agregar */
.mep-inline-add {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
  margin-top: 2px;
}
.mep-add-input {
  flex: 1;
  min-width: 120px;
  background: var(--q-input-bg, #0e1822);
  border: 1px solid var(--q-green, #00e676);
  border-radius: 6px;
  color: var(--q-text);
  padding: 5px 10px;
  font-size: .78rem;
}
.mep-add-input--sm {
  flex: 0 0 90px;
  min-width: 70px;
}
.mep-add-input:focus { outline: none; }
.mep-add-ok, .mep-add-cancel {
  width: 26px;
  height: 26px;
  border-radius: 50%;
  border: none;
  cursor: pointer;
  font-size: .75rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  flex-shrink: 0;
}
.mep-add-ok {
  background: rgba(0,230,118,.15);
  color: var(--q-green, #00e676);
}
.mep-add-ok:not(:disabled):hover { background: rgba(0,230,118,.25); }
.mep-add-ok:disabled { opacity: .4; cursor: default; }
.mep-add-cancel {
  background: rgba(255,68,68,.1);
  color: var(--q-red, #ff4444);
}
.mep-add-cancel:hover { background: rgba(255,68,68,.2); }
.mep-add-error {
  font-size: .72rem;
  color: var(--q-red, #ff4444);
  width: 100%;
}

/* Grid de mercados */
.mep-radio-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

/* Fila de opciones */
.mep-radio-row {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

/* Pill radio */
.mep-hidden { display: none; }
.mep-pill {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 10px;
  border-radius: 20px;
  border: 1px solid var(--q-border-md, #2a3d50);
  background: transparent;
  color: var(--q-muted);
  font-size: .72rem;
  font-weight: 600;
  cursor: pointer;
  transition: background .12s, border-color .12s, color .12s;
  user-select: none;
}
.mep-pill:hover { border-color: var(--q-green, #00e676); color: var(--q-green, #00e676); }
.mep-pill.active {
  background: rgba(0,230,118,.1);
  border-color: var(--q-green, #00e676);
  color: var(--q-green, #00e676);
}
.mep-pill--lg { padding: 6px 14px; font-size: .78rem; border-radius: 8px; }
.mep-pill-cod { font-weight: 800; }
.mep-pill-desc { font-weight: 400; color: var(--q-muted); font-size: .68rem; }
.mep-pill--lg.active .mep-pill-desc { color: inherit; }

/* Select segmentación */
.mep-select {
  width: 100%;
  background: var(--q-input-bg, #0e1822);
  border: 1px solid var(--q-border-md, #2a3d50);
  border-radius: 8px;
  color: var(--q-text);
  padding: 7px 12px;
  font-size: .8rem;
  appearance: auto;
}
.mep-select:focus { outline: none; border-color: var(--q-green, #00e676); }

/* Error */
.mep-error {
  margin-top: 12px;
  font-size: .8rem;
  color: var(--q-red, #ff4444);
}

/* Acciones */
.mep-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 24px;
}
.mep-btn {
  padding: 8px 20px;
  border-radius: 8px;
  font-size: .82rem;
  font-weight: 700;
  border: none;
  cursor: pointer;
  transition: opacity .15s;
}
.mep-btn:disabled { opacity: .45; cursor: default; }
.mep-btn--sec {
  background: var(--q-btn-ghost-bg, #1a2535);
  color: var(--q-muted);
}
.mep-btn--sec:not(:disabled):hover { opacity: .8; }
.mep-btn--pri {
  background: var(--q-gold, #d4af37);
  color: var(--q-gold-on, #000);
}
.mep-btn--pri:not(:disabled):hover { opacity: .85; }

/* Responsive */
@media (max-width: 480px) {
  .mep-wrap { padding: 16px 16px; }
  .mep-radio-row { flex-direction: column; }
  .mep-inline-add { flex-direction: column; align-items: flex-start; }
  .mep-add-input, .mep-add-input--sm { flex: unset; width: 100%; }
}
</style>
